// extracted by css-extract-rspack-plugin
export default {"hud":"tYT99I","line":"gduqNV","halo":"iu104Y","stroke":"kx9sVP","crosshair":"I9enev","readout":"ds7n9o"};